import { routes } from '@twiliointernal/e2-commons-shared-definitions';

import * as types from './types';

const LOG_PREFIX = '[Support Plans]';

const initialValue: types.SupportPlanProviderContext = {
  loading: false,
  hasError: false,
  hasPersonalizedSupportPlan: false,
  hasDeveloperSupport: false,
  otherPlansUrl: routes.supportPlans,
  supportPlan: undefined,
  pendingPlan: undefined,
};

export default {
  LOG_PREFIX,
  initialValue,
};
